import React from 'react';

interface CompanyVerificationPendingProps {
  verificationInfo: {
    verification_id: string;
    expires_at: string;
    emails_sent_to: string[];
  };
}

const CompanyVerificationPending: React.FC<CompanyVerificationPendingProps> = ({ 
  verificationInfo 
}) => {
  const expiresAt = new Date(verificationInfo.expires_at);
  
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
              <svg className="h-6 w-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            
            <h2 className="mt-6 text-center text-2xl font-extrabold text-gray-900">
              Verification Required
            </h2>
            
            <div className="mt-4 text-sm text-gray-600">
              <p className="mb-4">
                We've sent verification emails to existing company members. 
                Your request will be reviewed within 48 hours.
              </p>
              
              <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3 text-left">
                    <h3 className="text-sm font-medium text-blue-800">
                      What happens next?
                    </h3>
                    <div className="mt-2 text-sm text-blue-700">
                      <ul className="list-disc list-inside space-y-1">
                        <li>Company members will receive an email with your request</li>
                        <li>Any existing member can approve your request</li>
                        <li>You'll receive an email notification once approved</li>
                        <li>This request expires on {expiresAt.toLocaleDateString()} at {expiresAt.toLocaleTimeString()}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              
              {verificationInfo.emails_sent_to.length > 0 && (
                <div className="bg-gray-50 border border-gray-200 rounded-md p-4 mb-4">
                  <h4 className="text-sm font-medium text-gray-900 mb-2">
                    Verification emails sent to:
                  </h4>
                  <ul className="text-xs text-gray-600 space-y-1">
                    {verificationInfo.emails_sent_to.map((email, index) => (
                      <li key={index}>• {email}</li>
                    ))}
                  </ul>
                </div>
              )}
              
              <p className="text-xs text-gray-500">
                Verification ID: {verificationInfo.verification_id.substring(0, 8)}...
              </p>
            </div>
            
            <div className="mt-6">
              <button
                onClick={() => window.location.href = '/dashboard'}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Continue to Dashboard
              </button>
            </div>
            
            <div className="mt-4 text-xs text-gray-500">
              <p>
                Need help? Contact our support team with your verification ID.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyVerificationPending;